import lazyLoading from './lazyLoading'
import AuthLayout from '../components/Layouts/Auth.vue'
import DataShareGuard from './guards/data-share-guard'

export default [
  {
    path: '/data_share',
    component: AuthLayout,
    beforeEnter: DataShareGuard,
    children: [
      {
        name: 'data_share.appt',
        path: ':data_share_id/appt/:id',
        component: lazyLoading('Share/Appointment/AppointmentShare'),
        meta: {
          module: 'dataShare',
        },
      },
    ],
  },
]


